import cheader from '@/components/header/index.vue'
import caside from '@/components/aside/index.vue'

export default {
  name: 'user_good',
  data() {
    return {
      search: {
        name: '',
        glid: ''
      },
      search2: {
        name: '',
        manufacturer:"",
        recnumber:"",
        type:""
      },
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '已对码'
      }, {
        value: '0',
        label: '未对码'
      }, {
        value: '2',
        label: '已申请'
      },],
      value: '',
      unitID: 0,
      page: 1,
      page2: 1,
      loading:true,
      selectedGoods: [],
      detailinfo: [],
      goods: [],
      goods2: [],
      total: 0,
      total2: 0,
      curpage: 1,
      curpage2: 1,
      cates: [],
      brands: [],
      presclass: [],
      editFormVisiable: false,
      detailFormVisiable: false,
      codeFormVisiable: false,
      form: {},
      rows:{},
      rules: {
        name: {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        },
        brand: {
          required: true,
          message: '请选择品牌',
          trigger: 'change'
        },
        cates: {
          required: true,
          message: '请选择产品分类',
          trigger: 'change'
        },
        code: {
          required: true,
          message: '请输入助记码',
          trigger: 'blur'
        },
        numbering: {
          required: true,
          message: '请输入产品编码',
          trigger: 'blur'
        },
        recnumber: {
          required: true,
          message: '请输入批准文号',
          trigger: 'blur'
        },
        manufacturer: {
          required: true,
          message: '请输入生产厂家',
          trigger: 'blur'
        },
        specification: {
          required: true,
          message: '请输入产品规格',
          trigger: 'blur'
        },
        presclass: {
          required: true,
          message: '请选择处方分类',
          trigger: 'change'
        },
        formulation: {
          required: true,
          message: '请输入剂型',
          trigger: 'blur'
        },
        prounit: {
          required: true,
          message: '请输入产品单位',
          trigger: 'blur'
        },
        erp: {
          required: true,
          message: '请输入erp编码',
          trigger: 'blur'
        }
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    cheader,
    caside
  },
  created() {
    this.index(1)
    this.cateIndex()
    this.brandIndex()
    this.presclassIndex()
  },
  methods: {
    code(id, name,row) {
      this.rows = row
      this.search2.recnumber = name;
      this.search2.manufacturer = row.manufacturer
      this.search2.name = row.name
      this.search2.type = "init"
      this.unitID = id;
      this.codeFormVisiable = true
      this.$http.get('api/ucenter/productPublic', {
        params: {
          userId: this.user.id,
          search: this.search2,
          page: this.page2,
          pageSize: 10
        }
      }).then((res) => {

        res.data.data = res.data.data ? res.data.data : []

        for (let item of res.data.data) {
          item.glid = item.glid != undefined ? '已对码' : '未对码'

          if (item.image == '') {
            item.image = []
          } else {
            if (!item.image) {
            } else {
              item.image = item.image.split('|')
            }
          }
          if (item.cates == '') {
            item.cates = []
          } else {
            if (!item.cates) {


            } else {
              item.cates = item.cates.split(',')
            }
          }
          if (item.brand) {
            item.brand = item.brand.id
          } else {
            item.brand = ''
          }
        }
        this.goods2 = res.data.data
        this.total2 = res.data.total
      });
    },
    code2(page) {
      this.page2 = page
     this.search2.type = "search"
      this.$http.get('/api/ucenter/productPublic', {
        params: {
          userId: this.user.id,
          search: this.search2,
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        res.data.data = res.data.data ? res.data.data : []

        for (let item of res.data.data) {

          item.glid = item.glid != undefined ? '已对码' : '未对码'

          if (item.image == '') {
            item.image = []
          } else {
            if (!item.image) {
            } else {
              item.image = item.image.split('|')
            }
          }
          if (item.cates == '') {
            item.cates = []
          } else {
            if (!item.cates) {


            } else {
              item.cates = item.cates.split(',')
            }
          }
          if (item.brand) {
            item.brand = item.brand.id
          } else {
            item.brand = ''
          }
        }
        this.goods2 = res.data.data
        this.total2 = res.data.total
      })
    },
    match2() {
      this.$http.get('api/ucenter/applyMatch', { params: { id: this.unitID } }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "申请成功",
            type: 'success'
          });
          this.code2(this.page)
          this.codeFormVisiable = false
          this.index(this.page)
        } else {
          this.$message({
            message: res.data.message,
            type: 'info'
          });
        }
      });
    },
    async match(id) {
      this.$confirm('此操作将确定与此商品进行对码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('api/ucenter/matchCode', { params: { id: this.unitID, glid: id } }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "关联成功",
              type: 'success'
            });
            this.code2(this.page)
            this.codeFormVisiable = false
            this.index(this.page)
          } else {
            this.$message({
              message: res.data.message,
              type: 'info'
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        });
      });
    },
    download() {
      window.location.href = `${this.$store.state.config.serverUrl}/static/doc/品种导入模板.xlsx`
    },
    searchByTag() {
      this.search.glid = this.value
      this.index(1)
    },
    success(e) {
      this.$message({
        type: 'success',
        message: e.message
      });
    },
    async go(id) {
      const results = await this.$http.get('api/ucenter/productDetail', { params: { id } }).then((res) => {
        return res.data
      });
      this.detailinfo = results.data;
      this.detailFormVisiable = true
    },
    async del(id) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('api/ucenter/delProduct', { params: { id } }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.index(this.page)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    updatePrice(id, price) {
      this.$http.get('api/ucenter/updatePrice', { params: { id, price } }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
        }
      });
    },
    index(page) {
      this.page = page

      this.$http.get('/api/ucenter/product', {
        params: {
          userId: this.user.id,
          search: this.search,
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        this.loading=false
        res.data.data = res.data.data ? res.data.data : []
        for (let item of res.data.data) {
          item.glid = item.glid != undefined ? '已对码' : '未对码'

          if (item.image == '') {
            item.image = []
          } else {
            if (!item.image) {
            } else {
              item.image = item.image.split('|')
            }
          }
          if (item.cates == '') {
            item.cates = []
          } else {
            if (!item.cates) {


            } else {
              item.cates = item.cates.split(',')
            }
          }
          if (item.brand) {
            item.brand = item.brand.id
          } else {
            item.brand = ''
          }
        }
        this.goods = res.data.data
        this.total = res.data.total
        
      })
    },
    cateIndex() {
      this.$http.get('/api/category').then((res) => {
        this.cates = res.data.data
      })
    },
    brandIndex() {
      this.$http.get('/api/brand').then((res) => {
        this.brands = res.data.data
      })
    },
    presclassIndex() {
      this.$http.get('/api/chuffl').then((res) => {
        this.presclass = res.data.data
      })
    },
    resetForm(form) {
      this.$refs[form].resetFields()
      this.index(1)
    },
    handlEdit(good) {
      this.form = good
      this.editFormVisiable = true
    },
    handleSelectionChange(val) {
      this.selectedGoods = val
    },
    uploadImage(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post('/api/fileUpload', formData).then((res) => {
        if (res.data.success) {
          this.form.image.push(res.data.message)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    unApply(id) {
      this.$http.get('api/ucenter/unApply', { params: { id } }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
          this.detailFormVisiable = false;
          this.index(this.page)
        } else {
          this.$message({
            message: res.data.message,
            type: 'info'
          });
        }
      });
    },
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$set(this.form, 'userId', this.$store.state.user.id)
          this.$http.post('/api/ucenter/productAdd', this.form).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message)
              this.editFormVisiable = false
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/user/good/index/index.js